export const state = {
  ageGateToken: sessionStorage.getItem('ageGateToken')?true:false, 
  loggedIn: false,
  activeSection: 'beer',
  triggerSpring: 0,
  scrollMotion: 'upStart',
  edgeScrolling: 0,
  loaded: false
}